// extracted by mini-css-extract-plugin
export default {"mainContainer":"BridalServicesOfferings_mainContainer__lpD1r","title":"BridalServicesOfferings_title__dKoPc","content":"BridalServicesOfferings_content__wk1h6"};